<template>
  <v-card class="add-top-padding">
    <v-card-title>
      Participants who have not set their prize preferences
    </v-card-title>
    <v-card-text>
      <v-skeleton-loader
        v-if="loading"
        type="table"
      />

      <p
        v-else-if="missing.length === 0"
      >
        All set!
      </p>
      <v-list
        v-else
      >
        <v-list-item
          v-for="person in missing"
          :key="person.replace(' ', '-')"
        >
          <v-list-item-content>
            <v-list-item-title>
              {{ person }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import AdminClient from '@/api/AdminClient';
import { mapGetters } from 'vuex';

export default {
  name: 'PrizeSlackers',
  props: {
    currentUser: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: true,
      eventId: this.$store.state.hackathonID,
      missing: [],
    };
  },
  computed: {
    ...mapGetters({
      currentJwtToken: 'currentJwtToken',
    }),
  },
  mounted() {
    this.getPeopleMissingPrizes();
  },
  methods: {
    async getPeopleMissingPrizes() {
      this.loading = true;
      const client = new AdminClient(this.currentJwtToken);
      this.missing = await client.getPeopleWhoHaveNotSetPrizePreferences(this.eventId);
      this.loading = false;
    },
  },
};
</script>

<style lang="css" scoped>
  .add-top-padding {
    margin-top: 2rem;
  }
</style>
